// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"*","parentId":"@@/global-layout","id":"1"},"2":{"path":"/","parentId":"@@/global-layout","id":"2"},"@@/global-layout":{"id":"@@/global-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "editpages__PreviewClient__index" */'@/editpages/PreviewClient/index.tsx')),
'2': React.lazy(() => import(/* webpackChunkName: "editpages__PreviewClient__index" */'@/editpages/PreviewClient/index.tsx')),
'@@/global-layout': React.lazy(() => import(/* webpackChunkName: "layouts__index" */'/usr/src/app/src/layouts/index.tsx')),
},
  };
}
